// Shared install CTA rendered at the end of every blog post (BlogPost.js).
// The primary button targets the reader's detected browser; detection is
// deferred to useEffect because /blog/* pages are pre-rendered by react-snap
// (Chromium) — first client render must match the snapshot (Chrome default)
// or hydration dies. Same pattern as pages/Landing.js.

import React, { useEffect, useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Extension as ExtensionIcon } from '@mui/icons-material';
import {
  EXTENSION_URLS,
  APP_STORE_URL,
  detectBrowser,
  getExtensionUrl,
  getBrowserLabel,
} from '../config/extensionUrls';

const openStore = (url) => window.open(url, '_blank', 'noopener,noreferrer');

export default function PostCTA() {
  const [browser, setBrowser] = useState('chrome');

  useEffect(() => {
    setBrowser(detectBrowser());
  }, []);

  const otherBrowsers = Object.keys(EXTENSION_URLS).filter(b => b !== browser);

  return (
    <Box
      sx={(t) => ({
        mt: 6,
        p: { xs: 3, md: 4 },
        borderRadius: 2,
        border: `1px solid ${t.palette.divider}`,
        bgcolor: 'background.paper',
        textAlign: 'center',
      })}
    >
      <Typography variant="h6" component="p" fontWeight={700} sx={{ mb: 1 }}>
        Stop losing your tabs
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5, maxWidth: 520, mx: 'auto' }}>
        Blackmount saves your whole window in one click and restores it in Chrome,
        Firefox, Edge, Brave, Vivaldi, Opera, or on your iPhone. Free — works
        offline, no account needed.
      </Typography>
      <Stack
        direction="row"
        spacing={1}
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
      >
        <Button
          variant="contained"
          startIcon={<ExtensionIcon />}
          onClick={() => openStore(getExtensionUrl(browser))}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          Add to {getBrowserLabel(browser)} — Free
        </Button>
        {otherBrowsers.map(b => (
          <Button
            key={b}
            size="small"
            variant="outlined"
            onClick={() => openStore(getExtensionUrl(b))}
            sx={{ textTransform: 'none' }}
          >
            {getBrowserLabel(b)}
          </Button>
        ))}
        <Button
          size="small"
          variant="outlined"
          onClick={() => openStore(APP_STORE_URL)}
          sx={{ textTransform: 'none' }}
        >
          iPhone app
        </Button>
      </Stack>
    </Box>
  );
}
